import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import product from "../../images/Icons/product-icon.png";
import placeImage from "../../images/placeholder.jpg";
import { useDispatch, useSelector } from "react-redux";
import { fetchProduct } from "../../redux/slice/product";
import ShowcaseCardSkeleton from "../../Component/ShowcaseCardSkeleton";

export default function HomeProduct() {
  const imageOnError = (event) => {
    event.currentTarget.src = placeImage;
  };

  const dispatch = useDispatch();
  const { productData, isLoading, isError } = useSelector(
    (state) => state.product
  );
  const showSkeleton =
    isLoading || (productData.length === 0 && !isError);
  useEffect(() => {
    if (!isError) {
      dispatch(fetchProduct());
    }
  }, [dispatch, isError]);

  return (
    <>
      <div className="container-fluid">
        <div className="showcase-product mrty1">
          <div className="row-hd-txt">
            <div className="row-hd-txt-left">
              <img src={product} alt="icon" />
              <h5>Products You May Like</h5>
            </div>
          </div>
          {showSkeleton ? (
            <ShowcaseCardSkeleton count={4} />
          ) : (
            <div className="row shwc-pd-row">
              {productData.map((data, index) => {
                return (
                  <div className="col-lg-3 col-md-4 col-6 px-2" key={index}>
                    <Link to={`/product-list/${data.id}`} className="shwc-pd-dt">
                      <figure>
                        <img
                          src={data.thumbnail}
                          onError={imageOnError}
                          alt="product"
                        />
                      </figure>
                      <span className="fw-500 text-uppercase">{data.name}</span>
                      <button className="quote-btn">Get Best Price</button>
                    </Link>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
